import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';

@Component({
    selector: 'app-end-session',
    templateUrl: './end-session.component.html',
    styleUrls: ['./end-session.component.scss']
})
export class EndSessionComponent implements OnInit {

    isIdentification = true;
    title = 'Fin de l\'étape d\'authentification';
    extraMessageLigne1 = '';
    extraMessageLigne2 = '';

    constructor(private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        // Récupération des queryParams envoyés par le partenaire
        const queryParams: Params = this.activatedRoute.snapshot.queryParams;
        if (!queryParams) {
            return;
        }

        const actionId = queryParams.actionId;
        if (actionId === 'creationIdentiteNumerique') {
            const sigResult = queryParams.sigResult;
            if (sigResult === 'ALREADY_REPORTED') {
                this.extraMessageLigne1 = 'Vous possédez déjà un certificat de signature valide';
            } else if (sigResult === 'INVALID_INFOS_CLIENT') {
                this.extraMessageLigne1 = 'Vous n\'avez pas validé les informations saisies par votre notaire.';
                this.extraMessageLigne2 = 'Veuillez-vous rapprocher de lui pour la mise à jour de celles-ci.';
            } else {
                this.extraMessageLigne1 = ''; // Modification manuelle de l'url ? > Dans ce cas, on n'affiche rien
            }
        } else if (actionId === 'signatureProcuration') {
            this.isIdentification = false;
            this.title = 'Fin de l\'étape de signature';
            if (queryParams.sigResult === 'ALREADY_REPORTED') {
                this.extraMessageLigne1 = 'Vous avez déjà procédé à la signature de la procuration';
            }
        }
    }

    isIdentificationStep() {
        return this.isIdentification;
    }
}
